export default "/static/a469426b6d1f5994.png"